import { createPlannedGarmentPattern } from '@/lib/patterns/placeholder';
import { createGarmentContract, createIdentityMigrate } from '@/lib/patterns/contract';
import { buildWaistcoatBlocks } from '@/lib/patterns/waistcoat/blocks';
import { WAISTCOAT_DISPLAY_OPTIONS } from '@/lib/patterns/waistcoat/displayOptions';
import {
  WAISTCOAT_ACTIVE_GEOMETRY_VERSION,
  WAISTCOAT_GEOMETRY_V1,
} from '@/lib/patterns/waistcoat/version';

export const WAISTCOAT_DEFAULT_MEASUREMENTS = {
  chest: 40,
  waist: 34,
  shoulder: 17.5,
  back_length: 25,
  front_length: 27,
};

export { WAISTCOAT_DISPLAY_OPTIONS };

export function generateWaistcoatPattern() {
  return createPlannedGarmentPattern(
    'waistcoat',
    'Waistcoat base draft is planned after Shirt.',
  );
}

export const computeWaistcoat = generateWaistcoatPattern;

export const WAISTCOAT_CONTRACT = createGarmentContract({
  garment: 'waistcoat',
  defaults: WAISTCOAT_DEFAULT_MEASUREMENTS,
  compute: computeWaistcoat,
  version: WAISTCOAT_ACTIVE_GEOMETRY_VERSION,
  supportedVersions: [WAISTCOAT_GEOMETRY_V1],
  migrate: createIdentityMigrate(WAISTCOAT_ACTIVE_GEOMETRY_VERSION),
  blocks: buildWaistcoatBlocks,
  displayOptions: WAISTCOAT_DISPLAY_OPTIONS,
});
